declare global {
    const angular: ng.IAngularStatic;
}
import DataUtils from "./data-utils";

const phrase = angular.module("phrase", ['pascalprecht.translate', 'ng']);

phrase.value("phraseProjectId", "");
phrase.value("phraseEnabled", true);
phrase.value("phraseDecoratorPrefix", "{{__");
phrase.value("phraseDecoratorSuffix", "__}}");
phrase.value("phraseAutoLowercase", true);

phrase.config(["$provide", ($provide: angular.auto.IProvideService) => {
    return $provide.decorator("$translate", ["$delegate", "phraseEnabled", "phraseDecoratorPrefix", "phraseDecoratorSuffix",
        ($translate: any, phraseEnabled: boolean, phraseDecoratorPrefix: string, phraseDecoratorSuffix: string) => {
            if (phraseEnabled) {
                $translate._instant = $translate.instant;
                $translate.instant = translationId => `${phraseDecoratorPrefix}phrase_${translationId + phraseDecoratorSuffix}`;
            }
            return $translate;
        }]);
}]);

phrase.config(["$compileProvider", ($compileProvider: angular.ICompileProvider) => {
    return $compileProvider.directive('translate', ["phraseEnabled", "phraseDecoratorPrefix", "phraseDecoratorSuffix",
        (phraseEnabled: boolean, phraseDecoratorPrefix: string, phraseDecoratorSuffix: string) => {
            if (!phraseEnabled) {
                return {};
            }
            return {
                priority: 1001,
                terminal: true,
                restrict: 'AE',
                scope: true,
                compile: (elem, attr) => {
                    let translationId: string;
                    if (elem.attr("translate") != undefined) {
                        if (elem.attr("translate") !== ""){
                            translationId = elem.attr("translate");
                        } else {
                            translationId = elem.text();
                        }
                    }

                    if (translationId) {
                        let decoratedTranslationId = `${phraseDecoratorPrefix}phrase_${translationId + phraseDecoratorSuffix}`;
                        if (attr.translateValues) {
                            decoratedTranslationId = `${decoratedTranslationId} (${attr.translateValues})`;
                        }
                        elem.html(decoratedTranslationId);
                        elem.removeAttr("translate");
                    }
                }
            };
        }]);
}]);

phrase.directive("phraseJavascript", ["phraseEnabled", "phraseProjectId", "phraseAutoLowercase", "$window",
    (phraseEnabled: boolean, phraseProjectId: string, phraseAutoLowercase: boolean, $window: any) => {
        return {
            restrict: "EA",
            replace: true,
            link: (): void => {
                if (phraseEnabled) {
                    let url = `https://phraseapp.com/assets/in-context-editor/2.0/app.js?${new Date().getTime()}`;
                    $window.PHRASEAPP_CONFIG = {
                        projectId: phraseProjectId,
                        autoLowercase: phraseAutoLowercase,
                    };
                    DataUtils.getScript(url);
                }
            }
        };
    }]);
